import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Image = ({
  imageUrl = '',
  imageAlt = '',
  containerClass = '',
  imageClass = '',
  loaderClass = '',
  loaderalt = 'loader',
  role = 'progressbar',
  areaLive = false
}) => {
  const [loaded, setLoaded] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0
  });
  return (
    <div
      {...(areaLive ? { 'aria-live': 'polite' } : {})}
      className={containerClass}
      ref={ref}
    >
      <LazyLoadImage
        src="/content/images/loader/loading.gif"
        alt={loaderalt}
        className={loaderClass}
        hidden={loaded}
        role={role}
      />
      {(loaded || inView) && (
        <img
          src={imageUrl}
          alt={imageAlt}
          onLoad={() => {
            setLoaded(true);
          }}
          hidden={!loaded}
          className={imageClass}
        />
      )}
    </div>
  );
};

export default Image;
